export default __webpack_public_path__ + "static/media/ninja.51eab512.svg";